// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IPlateStatusType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class PlateStatusType implements IPlateStatusType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Active PlateStatusType
	**/
    get Active(): IPlateStatusType {
        return this.FromId(1);
    }
    /**
		Returns Canceled PlateStatusType
	**/
    get Canceled(): IPlateStatusType {
        return this.FromId(2);
    }
    /**
		Returns Replaced PlateStatusType
	**/
    get Replaced(): IPlateStatusType {
        return this.FromId(3);
    }
    /**
		Returns Reserved PlateStatusType
	**/
    get Reserved(): IPlateStatusType {
        return this.FromId(4);
    }

    get Converted(): IPlateStatusType {
        return this.FromId(5);
    }
    get ConvertedReserved(): IPlateStatusType {
        return this.FromId(6);
    }
    /**
		Returns Allocated PlateStatusType
	**/
    get Allocated(): IPlateStatusType {
        return this.FromId(13);
    }
    /**
		Returns Allocated Reserved PlateStatusType
	**/
    get AllocatedReserved(): IPlateStatusType {
        return this.FromId(14);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Active', displayValue: 'Active', description: 'Active', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, value: 'Canceled', displayValue: 'Canceled', description: 'Canceled', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, value: 'Replaced', displayValue: 'Replaced', description: 'Replaced', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, value: 'Reserved', displayValue: 'Reserved', description: 'Reserved', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, value: 'Converted', displayValue: 'Converted', description: 'Converted', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, value: 'ConvertedReserved', displayValue: 'ConvertedReserved', description: 'ConvertedReserved', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, value: 'Allocated', displayValue: 'Allocated', description: 'Plate is part of a bulk order', sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, value: 'AllocatedReserved', displayValue: 'Allocated Reserved', description: 'Allocated plate is reserved in a transaction', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IPlateStatusType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IPlateStatusType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IPlateStatusType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IPlateStatusType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IPlateStatusType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
